import HttpClient from "libs/utils/HttpClient";
import qs from "qs";

class HealthInsuranceStep {
  async getHealthInsuranceList({ personalID, draftId }) {
    try {
      const params = qs.stringify({
        ...(personalID && { personalID }),
        ...(draftId && { draftId }),
      });

      const response = await HttpClient.get(
        `/api/visaform/healthinsurance/list?${params}`
      );
      if (response.status) return response;
      return Promise.reject(response);
    } catch (error) {
      const newError = error;
      throw newError;
    }
  }

  async addHealthInsurance(body) {
    try {
      const response = await HttpClient.post(
        `/api/visaform/healthinsurance/add`,
        body
      );
      if (response.status) return response;
      return Promise.reject(response);
    } catch (error) {
      const newError = error;
      throw newError;
    }
  }

  async sendHealthInsurance(body) {
    try {
      const response = await HttpClient.post(
        `/api/visaform/healthinsurance/send`,
        body
      );
      if (response.status) return response;
      return Promise.reject(response);
    } catch (error) {
      const newError = error;
      throw newError;
    }
  }
}

export default new HealthInsuranceStep();
